import { Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import {
  ConfigFieldControl,
  FormConfigRequired,
  FormConfigTitleDescription,
  useFormContext
} from '@sierralabs/forms-ui';

export interface FormPickerConfig {
  multiple?: boolean;
  placeholder?: string;
}

export interface FormConfigPickerProps {
  disableMultiple?: boolean;
}

export const FormConfigPicker = <FormValuesType extends object>(
  props: FormConfigPickerProps
) => {
  const { disableMultiple } = props;
  const { formState, setFormState, notifyFormEdit } = useFormContext<
    FormValuesType,
    FormPickerConfig
  >();
  const element = formState.selectedFormElement!;
  if (!element.config) element.config = {};
  return (
    <>
      <FormConfigTitleDescription />
      <FormConfigRequired />
      <ConfigFieldControl>
        <TextField
          fullWidth
          variant='outlined'
          label='Placeholder'
          value={element.config?.placeholder || ''}
          onChange={event => {
            element.config!.placeholder = event.target.value;
            setFormState({ ...formState, selectedFormElement: element });
            notifyFormEdit();
          }}
        />
      </ConfigFieldControl>
      <ConfigFieldControl>
        <FormControlLabel
          label='Multiple'
          control={
            <Checkbox
              color='primary'
              disabled={disableMultiple}
              checked={Boolean(element.config!.multiple)}
              onChange={() => {
                element.config!.multiple = !element.config!.multiple;
                setFormState({ ...formState, selectedFormElement: element });
                notifyFormEdit();
              }}
            />
          }
        />
      </ConfigFieldControl>
    </>
  );
};
